import { ITradein } from '@/models/ITradein'
import { IConfigSeller } from '@/models/configSeller'
import { isValidImei } from '@/utils/isValidImei'

/** El seller tiene evaluación IA habilitada para la categoría del equipo. */
export const hasIAEvaluation = (configSeller: IConfigSeller, idSbu: number): boolean =>
  configSeller.config.permisos.ENABLE_IAEVALUATION === 1 &&
  configSeller.config.permisos.SBUS_IA_EVALUATION.includes(idSbu)

/** Queda un recálculo pendiente: hasta resolverlo no se puede evaluar. */
export const hasPendingRecalculate = (tradein: ITradein): boolean =>
  tradein.recalculate !== '0' && tradein.wasRecalculated !== 1

/** Smartphone con IMEI detectado inválido: hasta ingresarlo a mano no se puede evaluar. */
export const hasInvalidImei = (tradein: ITradein): boolean =>
  tradein.sbu === 'Smartphone' && !!tradein.serie && !isValidImei(tradein.serie)

/** Queda una revisión de factibilidad pendiente: el modelo cotizado no coincide con el evaluado. */
export const hasPendingFeasibility = (tradein: ITradein): boolean =>
  tradein.cancel_reason === 'El modelo evaluado no esta disponible' &&
  tradein.isFeasible !== 1 &&
  tradein.model !== tradein.modelName

/**
 * Regla con la que el detalle del tradein decide si corresponde mostrar la evaluación
 * estética. Vive acá para que el detalle y el modal del listado no diverjan.
 */
export const canShowIAEvaluation = (configSeller: IConfigSeller, tradein: ITradein): boolean => {
  const isHuaweiOnlineChile = configSeller.config.s3.FOLDER_APP === 'ti_huawei_online_cl'
  const isHuaweiOnlineMexico = configSeller.config.s3.FOLDER_APP === 'ti_huawei_online_mx'
  const isHuaweiOnlinePeru = configSeller.config.s3.FOLDER_APP === 'ti_huawei_online_pe'
  const iaEnabled = hasIAEvaluation(configSeller, tradein.id_sbu)

  const evaluable = iaEnabled &&
    tradein.serie !== null &&
    tradein.serie !== '' &&
    tradein.id_status !== 8 &&
    !hasPendingRecalculate(tradein) &&
    !hasPendingFeasibility(tradein)

  // Categoría D se puede volver a evaluar aunque el tradein esté cancelado.
  const rejectedByIA = tradein.cancel_reason === 'Evaluación IA: Categoría D' && tradein.id_status === 8
  const huaweiOnline = (isHuaweiOnlineChile || isHuaweiOnlineMexico || isHuaweiOnlinePeru) && iaEnabled && ![1, 2, 4].includes(tradein.id_status)

  return (evaluable || rejectedByIA || huaweiOnline) &&
    !([5, 7, 9].includes(tradein.id_status) && tradein.grade_IA === null)
}
